import { useForm } from "react-hook-form";
import * as yup from "yup";
import { Grid2 } from "@mui/material";
import { Search } from "@mui/icons-material";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormFiltersActualizacionInterface } from "../interfaces";
import CustomAccordion from "../../../../components/ui/materialui/customAccordion";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import InputRut from "../../../../components/inputs/yup/materialui/inputRut";
import InputText from '../../../../components/inputs/yup/materialui/inputText';
import { GetEncabezadosAct } from "../services/actLiquidacionDeudaService";
import { ResponseHeaderActDeuda } from "../models";

interface FiltrosComponentProps {
    handleFilters: (formFilters: FormFiltersActualizacionInterface) => void; //
};

//* Validacion del formulario
const validationSchema: yup.ObjectSchema<FormFiltersActualizacionInterface> = yup.object().shape({
    idSolicitud: yup
        .string()
        .matches(/^[0-9]+$/, "El ID de la solicitud debe contener solo números")
        .required("El ID de la solicitud es obligatorio"),
    idOperacion: yup
        .string()
        .matches(/^[0-9]+$/, "El ID de la operación debe contener solo números")
        .required("El ID de la operación es obligatorio"),
    rutCliente: yup.string(),
    rutNuevoProveedor: yup.string(),
    nombreNuevoProveedor: yup.string(),
    portaTodos: yup.boolean(),
});

export const FiltrosComponent = ({ handleFilters }: FiltrosComponentProps) => {

    const {
        handleSubmit,
        control,
        setValue,
        formState: { errors, isSubmitSuccessful }
    } = useForm<FormFiltersActualizacionInterface>({
        resolver: yupResolver(validationSchema),
        defaultValues: {},
    });

    const onSubmit = async (data: FormFiltersActualizacionInterface) => {

        const response = await GetEncabezadosAct(Number(data.idSolicitud), Number(data.idOperacion));
        if( response.status !== 200 ) return;
        
        const headerSummary = response.data as ResponseHeaderActDeuda;
        setValue('nombreNuevoProveedor', headerSummary.nomNewProv);
        setValue('rutCliente', headerSummary.rutCliente);
        setValue('rutNuevoProveedor', headerSummary.rutNewProv);

        handleFilters({ idOperacion: data.idOperacion, idSolicitud: data.idSolicitud, nombreNuevoProveedor: headerSummary.nomNewProv, rutCliente: headerSummary.rutCliente, rutNuevoProveedor:headerSummary.rutNewProv });
    }

    return (
        <CustomAccordion title="Filtros" expandedDefault>
            <form onSubmit={handleSubmit(onSubmit)}>

                <Grid2 container spacing={2} sx={{ 
                    marginTop: 1,
                    alignItems: "center",
                }}>

                    <Grid2 size={3}>
                        <InputText
                            label="ID solicitud portabilidad"
                            name="idSolicitud"
                            control={control}
                            error={errors.idSolicitud}
                        />
                    </Grid2>

                    <Grid2 size={3}>
                        <InputText
                            label="ID operación portabilidad"
                            name="idOperacion"
                            control={control}
                            error={errors.idOperacion}
                        />
                    </Grid2>

                </Grid2>

                <Grid2 container spacing={2} sx={{
                    marginTop: 1,
                    alignItems: "center",
                    display: isSubmitSuccessful ? "" : "none"
                }}>

                    <Grid2 size={3}>
                        <InputRut
                            label="Rut cliente"
                            name={"rutCliente"}
                            control={control}
                            error={errors.rutCliente}
                            readonly
                        />
                    </Grid2>

                    <Grid2 size={3}>
                        <InputRut
                            label="Rut nuevo proveedor"
                            name={"rutNuevoProveedor"}
                            control={control}
                            error={errors.rutNuevoProveedor}
                            readonly
                        />
                    </Grid2>

                    <Grid2 size={3}>
                        <InputText
                            label="Nombre nuevo proveedor"
                            name="nombreNuevoProveedor"
                            control={control}
                            error={errors.nombreNuevoProveedor}
                            readonly
                        />
                    </Grid2>
                </Grid2>

                {/* Contenedor del Botón */}
                <Grid2 size={{ xs: 8 }} sx={{ 
                    marginTop: '10px',
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                }}>
                    <MButton
                        type="submit"
                        variant="contained"
                        color="primary"
                        startIcon={<Search />}
                        sx={{ 
                            height: "40px", 
                            whiteSpace: "nowrap",
                            px: 3
                        }}
                    >
                        Buscar
                    </MButton>
                </Grid2>
            </form>
        </CustomAccordion>
    );

}